import { render, staticRenderFns } from "./OrdenServicioContentComponent.vue?vue&type=template&id=6c7319f6&"
import script from "./OrdenServicioContentComponent.vue?vue&type=script&lang=js&"
export * from "./OrdenServicioContentComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports